import React, { useEffect, useState } from 'react';

const SLOTS = [
  { side: 'left',  topDesktop: '20%', texts: ['be honest — do you miss me?', 'did you ever like me, like that?', "do you think about me when we don't talk?"] },
  { side: 'right', topDesktop: '20%', texts: ['would you date me if things were different?', "why'd you really pull away?", 'if I asked you out, what would you say?'] },
  { side: 'left',  topDesktop: '62%', texts: ["what's your actual first impression of me?", 'be real — am I annoying you?', 'would you be honest with me?'] },
  { side: 'right', topDesktop: '62%', texts: ['do you actually like me or are you just bored?', 'what do you really think of me?', 'would your friends date me?'] },
] as const;

function PopupCard({ text, small, side }: { text: string; small?: boolean; side?: 'left' | 'right' }) {
  const isRight = side === 'right';
  const bubbleColor = isRight ? '#005C4B' : '#1F2C34';
  const maxW = small ? 160 : 210;
  const fontSize = small ? 11 : 13;
  const tailSize = small ? 7 : 9;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: isRight ? 'flex-end' : 'flex-start',
      gap: 3,
      maxWidth: maxW,
    }}>
      {!isRight && (
        <span style={{
          fontSize: small ? 9 : 11,
          fontWeight: 600,
          color: '#e8365d',
          paddingLeft: 10,
          fontFamily: "'Segoe UI', sans-serif",
        }}>
          anonymous
        </span>
      )}

      <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'flex-end' }}>
        {!isRight && (
          <div style={{
            position: 'absolute',
            left: -tailSize + 1,
            bottom: 0,
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: `0 0 ${tailSize}px ${tailSize}px`,
            borderColor: `transparent transparent transparent ${bubbleColor}`,
            filter: 'drop-shadow(-1px 1px 1px rgba(0,0,0,0.3))',
          }} />
        )}

        <div style={{
          background: bubbleColor,
          borderRadius: isRight ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
          padding: small ? '7px 10px 5px' : '9px 13px 7px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.5)',
          maxWidth: maxW,
        }}>
          <p style={{
            margin: 0,
            fontSize,
            color: '#E9EDEF',
            lineHeight: 1.5,
            wordBreak: 'break-word',
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            {text}
          </p>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 4,
            marginTop: 3,
          }}>
            <span style={{ fontSize: small ? 8 : 9, color: 'rgba(233,237,239,0.45)', fontFamily: "'Segoe UI', sans-serif" }}>
              via Yhuu · now
            </span>
            <svg width={small ? 12 : 14} height={small ? 7 : 8} viewBox="0 0 16 9" fill="none">
              <path d="M1 4.5L5 8.5L11 1.5" stroke="#53BDEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 4.5L10 8.5L16 1.5" stroke="#53BDEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {isRight && (
          <div style={{
            position: 'absolute',
            right: -tailSize + 1,
            bottom: 0,
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: `0 ${tailSize}px ${tailSize}px 0`,
            borderColor: `transparent ${bubbleColor} transparent transparent`,
            filter: 'drop-shadow(1px 1px 1px rgba(0,0,0,0.3))',
          }} />
        )}
      </div>
    </div>
  );
}

export default function NGLPopups() {
  const [textIdx, setTextIdx] = useState([0, 0, 0, 0]);
  const [opacity, setOpacity] = useState([0, 0, 0, 0]);
  const [slideIn, setSlideIn] = useState([false, false, false, false]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  function showSlot(i: number) {
    setSlideIn(prev => { const n = [...prev]; n[i] = true; return n; });
    setOpacity(prev => { const n = [...prev]; n[i] = 1; return n; });
  }
  function hideSlot(i: number) {
    setSlideIn(prev => { const n = [...prev]; n[i] = false; return n; });
    setOpacity(prev => { const n = [...prev]; n[i] = 0; return n; });
  }
  function bumpText(i: number) {
    setTextIdx(prev => { const n = [...prev]; n[i] = (n[i] + 1) % SLOTS[i].texts.length; return n; });
  }

  useEffect(() => {
    // Rolling sequence: 4 slots cycling in one at a time, one leaves as next arrives
    // Always exactly 2 visible. Order: 0→1→2→3→0→1…
    // Step pattern (every STEP ms):
    //   t=0:    show 0
    //   t=1:    show 1
    //   t=2:    show 2, hide 0
    //   t=3:    show 3, hide 1
    //   t=4:    show 0 (new text), hide 2
    //   t=5:    show 1 (new text), hide 3
    //   … repeats

    const STEP = 2000; // ms between each arrival/departure

    // Initial: stagger show 0 and 1
    setTimeout(() => showSlot(0), 600);
    setTimeout(() => showSlot(1), 600 + STEP);

    let tick = 2; // next slot to show
    const interval = setInterval(() => {
      const incoming = tick % 4;
      const outgoing = (tick + 2) % 4; // the one that arrived 2 steps ago

      // Bump text on incoming slot before showing
      bumpText(incoming);
      showSlot(incoming);
      hideSlot(outgoing);

      tick++;
    }, STEP);

    return () => clearInterval(interval);
  }, []);

  if (isMobile) {
    return null;
  }

  return (
    <div aria-hidden="true" style={{
      position: 'absolute', inset: 0,
      pointerEvents: 'none', zIndex: 3,
      overflow: 'visible',
    }}>
      {SLOTS.map((slot, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            top: slot.topDesktop,
            ...(slot.side === 'left' ? { left: -220 } : { right: -220 }),
            opacity: opacity[i],
            transform: slideIn[i]
              ? 'translateX(0) scale(1)'
              : (slot.side === 'left' ? 'translateX(-24px) scale(0.93)' : 'translateX(24px) scale(0.93)'),
            transition: 'opacity 0.45s ease, transform 0.45s cubic-bezier(0.34,1.56,0.64,1)',
          }}
        >
          <PopupCard text={slot.texts[textIdx[i]]} side={slot.side} />
        </div>
      ))}
    </div>
  );
}
